
export const PARTICIPANT_STATES = {
	REMOTE: 0,
	PRESENT: 1,
	REPRESENTATED: 2,
	DELEGATED: 4,
	PHYSICALLY_PRESENT: 5,
	NO_PARTICIPATE: 6,
	PRESENT_WITH_REMOTE_VOTE: 7,
	SENT_VOTE_LETTER: 8,
	REMOTE_VOTE: 9,
	PRESENT_VOTE: 10,
	LEFT: 11,
	EARLY_VOTE: 12
};

export const AGENDA_TYPES = {
	INFORMATIVE: 0,
	PUBLIC_VOTING: 1,
	PUBLIC_ACT: 2,
	FAKE_PUBLIC_VOTING: 3,
	PRIVATE_ACT: 4,
	PRIVATE_VOTING: 5,
	CUSTOM_PUBLIC: 8,
	CUSTOM_PRIVATE: 7,
	CUSTOM_NOMINAL: 6,
	CONFIRMATION_REQUEST: 9
};

// CONTINUATION OF AGENDA_TYPES
export const CUSTOM_AGENDA_VOTING_TYPES = [
	{
		label: 'public_voting',
		value: 6
	},
	{
		label: 'private_voting',
		value: 7
	},
	{
		label: 'fake_public_votation',
		value: 8
	}
];

export const VOTE_VALUES = {
	VOTED: -2,
	NO_VOTE: -1,
	NEGATIVE: 0,
	POSITIVE: 1,
	ABSTENTION: 2
};

/* Custom agendas have an aditional Abstention item that is special since
*  If choosen o a multiple option agenda it overrides options.minSelections
*  and will empty the chosen values array
*/
export const CUSTOM_ABSTENTION_AGENDAS = {
	value: VOTE_VALUES.ABSTENTION,
	text: '',
	label: 'abstention',
};

export const DEFAULT_ITEMS_AGENDA = [
	{
		value: VOTE_VALUES.POSITIVE,
		text: '',
		label: 'yes'
	},
	{
		value: VOTE_VALUES.NEGATIVE,
		text: '',
		label: 'no'
	},
	{
		value: VOTE_VALUES.ABSTENTION,
		text: '',
		label: 'abstention'
	}
];

export const CONFIRMATION_ITEMS_AGENDA = [
	{
		value: VOTE_VALUES.POSITIVE,
		text: '',
		label: 'yes'
	},
	{
		value: VOTE_VALUES.NEGATIVE,
		text: '',
		label: 'no'
	}
];

/* Agenda blocks */
export const INFORMATIVE_AGENDAS = AGENDA_TYPES.INFORMATIVE;
export const DEFAULT_AGENDAS = [AGENDA_TYPES.PUBLIC_VOTING, AGENDA_TYPES.PUBLIC_ACT,
	AGENDA_TYPES.FAKE_PUBLIC_VOTING, AGENDA_TYPES.PRIVATE_ACT, AGENDA_TYPES.PRIVATE_VOTING];
export const CUSTOM_AGENDAS = [AGENDA_TYPES.CUSTOM_NOMINAL, AGENDA_TYPES.CUSTOM_PRIVATE, AGENDA_TYPES.CUSTOM_PUBLIC];
export const CONFIRMATION_AGENDAS = [AGENDA_TYPES.CONFIRMATION_REQUEST];

export const MAX_FILE_SIZE = 20000; // in KB

export const PARTICIPANT_TYPE = {
	PARTICIPANT: 0,
	GUEST: 1,
	REPRESENTATIVE: 2,
	REPRESENTATED: 3
};

export const COLORS = {
	primary: '#154481',
	secondary: '#ffffff',
	light: '#e8ecf2',
	dark: '#0b2241',
	background: '#FFFFFF',
	text: '#154481',
	success: '#61B78A',
	warning: '#F4AB66',
	error: '#DC7575',
	deactivated: '#B4B4B4',
};

export const LIGHT_COLOR_FACTOR = 0.90;
export const DARK_COLOR_FACTOR = 0.50;

export const NO_FORM_SECTIONS = ['home', 'documents'];
